module.exports = __webpack_public_path__ + "img/user-avatar.6d50d34a.png";